"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Header.default;
  }
});

var _Header = _interopRequireDefault(require("./Header"));


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/elements/Header/index.js
// module id = 2185
// module chunks = 0